document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mc-sticky-product]').forEach((bar) => {
    const productInfo = bar.closest('product-info');
    const mainButton = productInfo?.querySelector('[id^="ProductSubmitButton-"]');
    const price = bar.querySelector('[data-mc-sticky-price]');
    const variant = bar.querySelector('[data-mc-sticky-variant]');
    const stickyButton = bar.querySelector('[data-mc-sticky-submit]');
    if (!mainButton || !stickyButton) return;
    bar.hidden = false;

    const sync = () => {
      const currentPrice = productInfo.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale');
      const checked = productInfo.querySelector('input[type="radio"][name^="options"]:checked');
      const nextPrice = currentPrice?.textContent?.trim() || '';
      const nextVariant = checked?.value || '';
      if (price && nextPrice && price.textContent.trim() !== nextPrice) price.textContent = nextPrice;
      if (variant && variant.textContent !== nextVariant) variant.textContent = nextVariant;
      stickyButton.disabled = mainButton.disabled;
      const nextLabel = mainButton.querySelector('span')?.textContent?.trim() || 'Ajouter au panier';
      if (stickyButton.textContent !== nextLabel) stickyButton.textContent = nextLabel;
    };
    sync();
    new MutationObserver(sync).observe(productInfo, { subtree: true, childList: true, characterData: true, attributes: true });
    stickyButton.addEventListener('click', () => mainButton.click());
    new IntersectionObserver(([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0.05 }).observe(mainButton);
  });
});
